(function () {
    'use strict';

    angular.module('annualCycleModule')
        .config(['$stateProvider', '$urlRouterProvider', routesConfig]);

    function routesConfig($stateProvider, $urlRouterProvider) {
        var internalPaths = window.paths;
        $stateProvider
            .state('oldActivityDetail', {	
                url: '/ac/activity/activityDetail/:activityId',	
                params: { activityId: '' },	
                templateUrl: internalPaths.FrontpageHome,	
                controller: 'homeController',	
                controllerAs: 'vm',	
                data: {	
                    title: 'Activity Detail',	
                    description: 'Activity Detail'	
                }	
            })
            .state('activityDetail', {
                url: '/ac/activity/:activityId', 
                params: { activityId: '' },
                templateUrl: internalPaths.FrontpageHome,
                controller: 'homeController',
                controllerAs: 'vm',
                data: {
                    title: 'Activity Detail',
                    description: 'Activity Detail'
                }
            })
            .state('oldTaskDetail', {	
                url: '/ac/task/taskDetail/:taskId',	
                params: { taskId: '' },	
                templateUrl: internalPaths.FrontpageHome,	
                controller: 'homeController',	
                controllerAs: 'vm',	
                data: {	
                    title: 'Task Detail',	
                    description: 'Task Detail'	
                }	
            })
            .state('taskDetail', {
                url: '/ac/task/:taskId', 
                params: { taskId: '' },
                templateUrl: internalPaths.FrontpageHome,
                controller: 'homeController',
                controllerAs: 'vm',
                data: {
                    title: 'Task Detail',
                    description: 'Task Detail'
                }
            })
            .state('activityList', {
                url: '/ac/home', 
                templateUrl: internalPaths.FrontpageHome,
                controller: 'homeController',
                controllerAs: 'vm',
                data: {
                    title: 'Activity List',
                    description: 'Activity List'
                }
            })
        $urlRouterProvider.otherwise('/');
    };
})();